<div
    class="dnd-area"
    (drop)="onDrop($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
>
    <ng-content></ng-content>
    <div
        class="dnd-area-message"
        [class.visible]="dndMessageVisible$ | async"
        [class.hidden]="(dndMessageVisible$ | async) === false"
    >
        <div class="dnd-area-message__title">Sleep je foto's in dit venster</div>
        <div class="dnd-area-message__description">Sleep je foto's in dit venster en laat ze vervolgens los om te uploaden.</div>
    </div>
</div>
